import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import geografiaFunciones from "../function/geografia.Funciones";
import {
  generarEdades,
  generarGruposSanguineos,
  generarSexos,
} from "../function/listascomunes.Funciones";
import { normalizeImage } from "../utils/image";

const MODULO = "Aprendices";

const normalizarTexto = (texto = "") =>
  String(texto)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const RegistrarAprendices = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const aprendizFromState = state?.aprendiz;

  const [edit, setEdit] = useState(false);

  const [documentoAprendiz, setDocumentoAprendiz] = useState("");
  const [tipodocumentoAprendiz, setTipodocumentoAprendiz] = useState("");
  const [nombre1Aprendiz, setNombre1Aprendiz] = useState("");
  const [nombre2Aprendiz, setNombre2Aprendiz] = useState("");
  const [apellido1Aprendiz, setApellido1Aprendiz] = useState("");
  const [apellido2Aprendiz, setApellido2Aprendiz] = useState("");

  const [fechanacimientoAprendiz, setFechanacimientoAprendiz] = useState("");
  const [edadAprendiz, setEdadAprendiz] = useState("");
  const [sexoAprendiz, setSexoAprendiz] = useState("");
  const [rhAprendiz, setRhAprendiz] = useState("");
  const [emailAprendiz, setEmailAprendiz] = useState("");

  const [telefono1Aprendiz, setTelefono1Aprendiz] = useState("");
  const [telefono2Aprendiz, setTelefono2Aprendiz] = useState("");
  const [direccionAprendiz, setDireccionAprendiz] = useState("");

  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);

  const [paisAprendiz, setPaisAprendiz] = useState("");
  const [estadoAprendiz, setEstadoAprendiz] = useState("");
  const [ciudadAprendiz, setCiudadAprendiz] = useState("");

  const [paisSeleccionado, setPaisSeleccionado] = useState("");
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("");
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState("");

  const [estudiosAprendiz, setEstudiosAprendiz] = useState([
    { nivel: "", institucion: "", tituloObtenido: "", anioFinalizacion: "" },
  ]);

  const [acudientesAprendiz, setAcudientesAprendiz] = useState([
    {
      nombreAcudiente: "",
      tipodocumentoAcudiente: "",
      documentoAcudiente: "",
      lugardocumentoAcudiente: "",
      relacionAcudiente: "",
      telefonoAcudiente: "",
      emailAcudiente: "",
      acudientePrincipal: true,
    },
  ]);

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const previewRef = useRef("");
  const [uploadState, setUploadState] = useState(0);
  const [loading, setLoading] = useState(false);

  const [previewFirmaAprendiz, setPreviewFirmaAprendiz] = useState(null);
  const [previewFirmaAcudiente, setPreviewFirmaAcudiente] = useState(null);

  const [selectedAcudienteId, setSelectedAcudienteId] = useState(null);

  const edades = generarEdades();
  const sexos = generarSexos();
  const gruposSanguineos = generarGruposSanguineos();

  const authConfig = () => {
    const token = localStorage.getItem("token");

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const getModuloAprendices = () => {
    try {
      const permisosStorage = localStorage.getItem("permisos");
      const usuarioStorage = localStorage.getItem("usuario");
      const userStorage = localStorage.getItem("user");
      const usuariosStorage = localStorage.getItem("usuarios");

      const permisosData = permisosStorage
        ? JSON.parse(permisosStorage)
        : usuarioStorage
        ? JSON.parse(usuarioStorage)
        : userStorage
        ? JSON.parse(userStorage)
        : usuariosStorage
        ? JSON.parse(usuariosStorage)
        : {};

      const modulos = Array.isArray(permisosData)
        ? permisosData
        : permisosData?.modulos ||
          permisosData?.permisos ||
          permisosData?.usuario?.modulos ||
          permisosData?.usuario?.permisos ||
          permisosData?.user?.modulos ||
          permisosData?.user?.permisos ||
          [];

      return (
        modulos.find((modulo) => {
          const nombre =
            modulo?.nombreModulo ||
            modulo?.modulo ||
            modulo?.nombre ||
            modulo?.moduloObjectId?.nombreModulo ||
            modulo?.moduloObjectId?.nombre ||
            "";

          return normalizarTexto(nombre) === normalizarTexto(MODULO);
        }) || {}
      );
    } catch (error) {
      console.error("Error leyendo permisos:", error);
      return {};
    }
  };

  const moduloAprendices = getModuloAprendices();

  const puedeCrear =
    moduloAprendices?.puedeCrear === true ||
    moduloAprendices?.crear === true;

  const puedeLeer =
    moduloAprendices?.puedeLeer === true ||
    moduloAprendices?.leer === true;

  const puedeActualizar =
    moduloAprendices?.puedeActualizar === true ||
    moduloAprendices?.actualizar === true ||
    moduloAprendices?.editar === true ||
    moduloAprendices?.update === true;

  const puedeEliminar =
    moduloAprendices?.puedeEliminar === true ||
    moduloAprendices?.eliminar === true ||
    moduloAprendices?.delete === true;

  const tienePermisoFormulario = edit ? puedeActualizar : puedeCrear;

  useEffect(() => setEdit(!!id), [id]);

  const navegarFirmaAcudiente = (idAcudiente) => {
    if (!puedeActualizar) {
      Swal.fire(
        "Sin permisos",
        "No tiene permisos para registrar la firma del acudiente.",
        "warning"
      );
      return;
    }

    if (!id || !idAcudiente) return;
    navigate(`/aprendiz/registrarfirma/${id}/${idAcudiente}`);
  };

  const handleCancelOrClean = () => {
    if (edit) {
      navigate("/aprendiz/");
    } else {
      cleanData();
    }
  };

  const cleanData = () => {
    setDocumentoAprendiz("");
    setTipodocumentoAprendiz("");
    setNombre1Aprendiz("");
    setNombre2Aprendiz("");
    setApellido1Aprendiz("");
    setApellido2Aprendiz("");
    setFechanacimientoAprendiz("");
    setEdadAprendiz("");
    setSexoAprendiz("");
    setRhAprendiz("");
    setEmailAprendiz("");
    setTelefono1Aprendiz("");
    setTelefono2Aprendiz("");
    setDireccionAprendiz("");
    setPaisAprendiz("");
    setEstadoAprendiz("");
    setCiudadAprendiz("");
    setPaisSeleccionado("");
    setEstadoSeleccionado("");
    setCiudadSeleccionada("");
    setPaises([]);
    setEstados([]);
    setCiudades([]);

    setEstudiosAprendiz([
      { nivel: "", institucion: "", tituloObtenido: "", anioFinalizacion: "" },
    ]);

    setAcudientesAprendiz([
      {
        nombreAcudiente: "",
        tipodocumentoAcudiente: "",
        documentoAcudiente: "",
        lugardocumentoAcudiente: "",
        relacionAcudiente: "",
        telefonoAcudiente: "",
        emailAcudiente: "",
        acudientePrincipal: true,
      },
    ]);

    setSelectedAcudienteId(null);
    setPreviewFirmaAprendiz(null);
    setPreviewFirmaAcudiente(null);

    if (preview && preview.startsWith("blob:")) {
      try {
        URL.revokeObjectURL(preview);
      } catch (e) {}
    }

    setImage(null);
    setPreview("");
    previewRef.current = "";

    const fileInput = document.getElementById("fileInput");
    if (fileInput) fileInput.value = "";

    const fileNameInput = document.getElementById("fileName");
    if (fileNameInput) fileNameInput.value = "";

    const label = document.getElementById("fileLabel");
    if (label) label.textContent = "Seleccionar / Cambiar";
  };

  useEffect(() => {
    const cargarPaises = async () => {
      try {
        setPaises([]);
        const paisesData = await geografiaFunciones.obtenerPaises();

        const paisesUnicos = paisesData.filter(
          (pais, index, self) =>
            index === self.findIndex((p) => p.idPais === pais.idPais)
        );

        setPaises(paisesUnicos);
      } catch (error) {
        console.error("Error al cargar países:", error);
      }
    };

    cargarPaises();
  }, []);

  const handlePaisChange = async (paisId) => {
    try {
      setPaisSeleccionado(paisId);
      setPaisAprendiz(paisId);
      setEstados([]);
      setCiudades([]);
      setEstadoSeleccionado("");
      setCiudadSeleccionada("");

      if (paisId) {
        const estadosData = await geografiaFunciones.obtenerEstadosPorPais(
          paisId
        );

        const estadosUnicos = estadosData.filter(
          (estado, index, self) =>
            index === self.findIndex((e) => e.idEstado === estado.idEstado)
        );

        setEstados(estadosUnicos);
      }
    } catch (error) {
      console.error("Error al cambiar el país:", error);
    }
  };

  const handleEstadoChange = async (estadoId) => {
    try {
      setEstadoSeleccionado(estadoId);
      setEstadoAprendiz(estadoId);
      setCiudades([]);
      setCiudadSeleccionada("");

      if (estadoId) {
        const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(
          estadoId
        );

        const ciudadesUnicas = ciudadesData.filter(
          (ciudad, index, self) =>
            index === self.findIndex((c) => c.idCiudad === ciudad.idCiudad)
        );

        setCiudades(ciudadesUnicas);
      }
    } catch (error) {
      console.error("Error al cambiar el estado:", error);
    }
  };

  const handleCiudadChange = (ciudadId) => {
    setCiudadSeleccionada(ciudadId);
    setCiudadAprendiz(ciudadId);
  };

  useEffect(() => {
    let isMounted = true;

    const fetchAprendiz = async () => {
      try {
        if (!puedeLeer && !puedeActualizar) {
          Swal.fire(
            "Sin permisos",
            "No tiene permisos para consultar aprendices.",
            "warning"
          );
          return;
        }

        const { data } = await axios.get(
          `/api/aprendices/listid/${id}`,
          authConfig()
        );

        if (!data?.ok) return;

        const aprendizData = data.message ?? {};

        const fechaNacimiento = aprendizData.fechanacimientoAprendiz
          ? new Date(aprendizData.fechanacimientoAprendiz)
              .toISOString()
              .split("T")[0]
          : "";

        if (!isMounted) return;

        setDocumentoAprendiz(aprendizData.documentoAprendiz ?? "");
        setTipodocumentoAprendiz(aprendizData.tipodocumentoAprendiz ?? "");
        setNombre1Aprendiz(aprendizData.nombre1Aprendiz ?? "");
        setNombre2Aprendiz(aprendizData.nombre2Aprendiz ?? "");
        setApellido1Aprendiz(aprendizData.apellido1Aprendiz ?? "");
        setApellido2Aprendiz(aprendizData.apellido2Aprendiz ?? "");
        setFechanacimientoAprendiz(fechaNacimiento);
        setEdadAprendiz(aprendizData.edadAprendiz ?? "");
        setSexoAprendiz(aprendizData.sexoAprendiz ?? "");
        setRhAprendiz(aprendizData.rhAprendiz ?? "");
        setEmailAprendiz(aprendizData.emailAprendiz ?? "");
        setTelefono1Aprendiz(aprendizData.telefono1Aprendiz ?? "");
        setTelefono2Aprendiz(aprendizData.telefono2Aprendiz ?? "");
        setDireccionAprendiz(aprendizData.direccionAprendiz ?? "");
        setPaisAprendiz(aprendizData.paisAprendiz ?? "");
        setEstadoAprendiz(aprendizData.estadoAprendiz ?? "");
        setCiudadAprendiz(aprendizData.ciudadAprendiz ?? "");

        setEstudiosAprendiz(
          Array.isArray(aprendizData.estudiosAprendiz) &&
            aprendizData.estudiosAprendiz.length > 0
            ? aprendizData.estudiosAprendiz
            : [
                {
                  nivel: "",
                  institucion: "",
                  tituloObtenido: "",
                  anioFinalizacion: "",
                },
              ]
        );

        setAcudientesAprendiz(
          Array.isArray(aprendizData.acudientesAprendiz) &&
            aprendizData.acudientesAprendiz.length > 0
            ? aprendizData.acudientesAprendiz
            : [
                {
                  nombreAcudiente: "",
                  tipodocumentoAcudiente: "",
                  documentoAcudiente: "",
                  lugardocumentoAcudiente: "",
                  relacionAcudiente: "",
                  telefonoAcudiente: "",
                  emailAcudiente: "",
                  acudientePrincipal: true,
                },
              ]
        );

        if (aprendizData.imgAprendiz) {
          setPreview(aprendizData.imgAprendiz);
          previewRef.current = aprendizData.imgAprendiz;
        }

        if (aprendizData.firmaAprendiz) {
          setPreviewFirmaAprendiz(aprendizData.firmaAprendiz);
        }

        const listaAcudientes = aprendizData.acudientesAprendiz ?? [];
        const principal =
          listaAcudientes.find((a) => a?.acudientePrincipal) ||
          listaAcudientes[0];

        if (principal?._id) setSelectedAcudienteId(principal._id);
        setPreviewFirmaAcudiente(principal?.firmaAcudiente || null);

        const paisesData = await geografiaFunciones.obtenerPaises();

        if (!isMounted) return;
        setPaises(paisesData);

        if (aprendizData.paisAprendiz) {
          const estadosData =
            await geografiaFunciones.obtenerEstadosPorPais(
              aprendizData.paisAprendiz
            );

          if (!isMounted) return;

          setEstados(estadosData);
          setPaisSeleccionado(aprendizData.paisAprendiz);
        }

        if (aprendizData.estadoAprendiz) {
          const ciudadesData =
            await geografiaFunciones.obtenerCiudadesPorEstado(
              aprendizData.estadoAprendiz
            );

          if (!isMounted) return;

          setCiudades(ciudadesData);
          setEstadoSeleccionado(aprendizData.estadoAprendiz);
        }

        if (aprendizData.ciudadAprendiz) {
          setCiudadSeleccionada(aprendizData.ciudadAprendiz);
        }
      } catch (error) {
        console.error("Error al obtener aprendiz:", error.message);

        if (error.response && !error.response.data?.ok) {
          Swal.fire({
            icon: "error",
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    };

    if (id) fetchAprendiz();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const acudientePrincipal = useMemo(() => {
    if (!Array.isArray(acudientesAprendiz)) return null;

    return (
      acudientesAprendiz.find((a) => a?.acudientePrincipal) ||
      acudientesAprendiz[0] ||
      null
    );
  }, [acudientesAprendiz]);

  const acudienteActual = useMemo(() => {
    if (!Array.isArray(acudientesAprendiz)) return null;

    if (selectedAcudienteId) {
      return (
        acudientesAprendiz.find(
          (a) => String(a?._id) === String(selectedAcudienteId)
        ) || null
      );
    }

    return acudientePrincipal;
  }, [acudientesAprendiz, selectedAcudienteId, acudientePrincipal]);

  useEffect(() => {
    setPreviewFirmaAcudiente(acudienteActual?.firmaAcudiente || null);
  }, [acudienteActual]);

  const handleFileChange = async (e) => {
    try {
      if (!tienePermisoFormulario) {
        Swal.fire(
          "Sin permisos",
          edit
            ? "No tiene permisos para actualizar aprendices."
            : "No tiene permisos para crear aprendices.",
          "warning"
        );
        return;
      }

      if (!e.target.files || !e.target.files[0]) return;

      const file = e.target.files[0];

      const isValidName = /\.(jpeg|jpg|png|svg|heic|heif)$/i.test(
        file.name || ""
      );

      const isValidType = /image\//.test(file.type || "");

      if (!isValidName && !isValidType) {
        Swal.fire({
          icon: "error",
          title: "Archivo no válido",
          text: "Usa .jpg, .jpeg, .png (o HEIC en iPhone)",
        });

        e.target.value = "";
        return;
      }

      const processed = await normalizeImage(file);

      if (preview && preview.startsWith("blob:")) {
        try {
          URL.revokeObjectURL(preview);
        } catch (err) {}
      }

      setImage(processed);

      const blobUrl = URL.createObjectURL(processed);
      setPreview(blobUrl);
      previewRef.current = blobUrl;

      const label = document.getElementById("fileLabel");
      const fileNameInput = document.getElementById("fileName");

      if (fileNameInput) fileNameInput.value = processed.name || "imagen.jpg";
      if (label) label.textContent = "Seleccionar / Cambiar";
    } catch (err) {
      console.error("Error procesando imagen:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo procesar la imagen.",
      });
    }
  };

  const agregarEstudio = (e) => {
    e.preventDefault();

    setEstudiosAprendiz((prev) => [
      ...prev,
      { nivel: "", institucion: "", tituloObtenido: "", anioFinalizacion: "" },
    ]);
  };

  const eliminarEstudio = (index) => {
    setEstudiosAprendiz((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEstudioChange = (index, event) => {
    const { name, value } = event.target;

    setEstudiosAprendiz((prev) =>
      prev.map((x, i) => (i === index ? { ...x, [name]: value } : x))
    );
  };

  const agregarAcudiente = (e) => {
    e.preventDefault();

    setAcudientesAprendiz((prev) => {
      if (prev.length >= 3) return prev;

      return [
        ...prev,
        {
          nombreAcudiente: "",
          tipodocumentoAcudiente: "",
          documentoAcudiente: "",
          lugardocumentoAcudiente: "",
          relacionAcudiente: "",
          telefonoAcudiente: "",
          emailAcudiente: "",
          acudientePrincipal: false,
        },
      ];
    });
  };

  const eliminarAcudiente = (index) => {
    setAcudientesAprendiz((prev) => {
      const nuevos = prev.filter((_, i) => i !== index);

      if (nuevos.length > 0 && !nuevos.some((a) => a?.acudientePrincipal)) {
        nuevos[0].acudientePrincipal = true;
      }

      if (selectedAcudienteId) {
        const existe = nuevos.some(
          (a) => String(a?._id) === String(selectedAcudienteId)
        );

        if (!existe) setSelectedAcudienteId(nuevos?.[0]?._id || null);
      }

      return [...nuevos];
    });
  };

  const handleAcudienteChange = (index, event) => {
    const { name, value, type, checked } = event.target;

    setAcudientesAprendiz((prev) => {
      const nuevos = [...prev];

      if (name === "acudientePrincipal" && checked) {
        nuevos.forEach((a, i) => {
          nuevos[i].acudientePrincipal = i === index;
        });
      } else {
        nuevos[index] = {
          ...nuevos[index],
          [name]: type === "checkbox" ? checked : value,
        };
      }

      return nuevos;
    });
  };

  const saveAprendiz = async (formData) => {
    try {
      setLoading(true);

      await axios.post("/api/aprendices/add", formData, {
        ...authConfig(),
        onUploadProgress: ({ loaded, total }) => {
          const percent = total ? parseInt((loaded * 100) / total) : 0;
          setUploadState(percent);
        },
      });

      setLoading(false);
      cleanData();

      Swal.fire({
        icon: "success",
        title: "El Aprendiz ha sido registrado con éxito",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate("/aprendiz/"));
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: "error",
        title: "Error al registrar",
        text: error.response?.data?.message || "Intenta de nuevo",
      });

      console.error("Error en saveAprendiz:", error.message);
    }
  };

  const updateAprendiz = async (formData) => {
    try {
      const { data } = await axios.put(
        `/api/aprendices/update/${id}`,
        formData,
        authConfig()
      );

      Swal.fire({
        icon: "success",
        title: data?.message || "Actualizado",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate("/aprendiz/"));
    } catch (error) {
      console.error("Error en updateAprendiz", error);

      Swal.fire({
        icon: "error",
        title: "Error en la actualización",
        text: error.response?.data?.message || "Intenta de nuevo",
      });
    }
  };

  const actions = async (e) => {
    e.preventDefault();

    if (!tienePermisoFormulario) {
      Swal.fire(
        "Sin permisos",
        edit
          ? "No tiene permisos para actualizar aprendices."
          : "No tiene permisos para crear aprendices.",
        "warning"
      );
      return;
    }

    const formData = new FormData();

    if (image) formData.append("imgAprendiz", image);

    const aprendizData = {
      documentoAprendiz,
      tipodocumentoAprendiz,
      nombre1Aprendiz,
      nombre2Aprendiz: nombre2Aprendiz ?? "",
      apellido1Aprendiz,
      apellido2Aprendiz: apellido2Aprendiz ?? "",
      edadAprendiz: edadAprendiz ?? 0,
      sexoAprendiz: sexoAprendiz ?? "",
      direccionAprendiz: direccionAprendiz ?? "",
      telefono1Aprendiz,
      telefono2Aprendiz: telefono2Aprendiz ?? "",
      fechanacimientoAprendiz: fechanacimientoAprendiz ?? "",
      rhAprendiz: rhAprendiz ?? "",
      emailAprendiz,
      paisAprendiz: paisAprendiz ?? 0,
      estadoAprendiz: estadoAprendiz ?? 0,
      ciudadAprendiz: ciudadAprendiz ?? 0,
    };

    Object.entries(aprendizData).forEach(([key, value]) =>
      formData.append(key, value)
    );

    (Array.isArray(estudiosAprendiz) ? estudiosAprendiz : []).forEach(
      (estudio, index) => {
        ["nivel", "institucion", "tituloObtenido", "anioFinalizacion"].forEach(
          (field) => {
            formData.append(
              `estudiosAprendiz[${index}][${field}]`,
              estudio?.[field] ?? ""
            );
          }
        );
      }
    );

    (Array.isArray(acudientesAprendiz)
      ? acudientesAprendiz.filter(Boolean)
      : []
    ).forEach((acudiente, index) => {
      if (acudiente?._id) {
        formData.append(`acudientesAprendiz[${index}][_id]`, acudiente._id);
      }

      const fields = [
        "nombreAcudiente",
        "tipodocumentoAcudiente",
        "documentoAcudiente",
        "lugardocumentoAcudiente",
        "relacionAcudiente",
        "telefonoAcudiente",
        "emailAcudiente",
      ];

      fields.forEach((f) =>
        formData.append(
          `acudientesAprendiz[${index}][${f}]`,
          acudiente?.[f] ?? ""
        )
      );

      formData.append(
        `acudientesAprendiz[${index}][acudientePrincipal]`,
        acudiente?.acudientePrincipal ? "true" : "false"
      );

      if (acudiente?.firmaAcudiente) {
        formData.append(
          `acudientesAprendiz[${index}][firmaAcudiente]`,
          acudiente.firmaAcudiente
        );
      }

      if (acudiente?.nameFirmaAcudiente) {
        formData.append(
          `acudientesAprendiz[${index}][nameFirmaAcudiente]`,
          acudiente.nameFirmaAcudiente
        );
      }
    });

    edit ? updateAprendiz(formData) : saveAprendiz(formData);
  };

  if (edit && !puedeActualizar) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          No tiene permisos para actualizar aprendices.
        </div>

        <button className="btn btn-dark" onClick={() => navigate("/aprendiz/")}>
          Volver
        </button>
      </div>
    );
  }

  if (!edit && !puedeCrear) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          No tiene permisos para registrar aprendices.
        </div>

        <button className="btn btn-dark" onClick={() => navigate("/aprendiz/")}>
          Volver
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <h4 className="mb-1 fw-semibold">
                {edit ? "Actualizar Aprendiz" : "Registrar Aprendiz"}
              </h4>

              <p className="mb-0 text-secondary small">
                Completa los datos. Campos con{" "}
                <span className="fw-semibold">*</span> son obligatorios.
              </p>
            </div>

            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-outline-dark"
                onClick={() => navigate(-1)}
                disabled={loading}
                title="Volver"
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                Volver
              </button>

              <button
                type="button"
                className={`btn ${
                  edit ? "btn-outline-danger" : "btn-outline-dark"
                }`}
                onClick={handleCancelOrClean}
                disabled={loading}
                title={edit ? "Cancelar" : "Limpiar"}
              >
                <i
                  className={`fa-solid ${
                    edit ? "fa-xmark" : "fa-eraser"
                  } me-2`}
                ></i>
                {edit ? "Cancelar" : "Limpiar"}
              </button>
            </div>
          </div>
        </div>

        <form onSubmit={actions}>
          <div className="bg-white border rounded-4 shadow-sm p-2 p-md-3 mb-3">
            <ul className="nav nav-pills gap-2 flex-wrap" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-datos"
                  type="button"
                  role="tab"
                >
                  Personal
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-familia"
                  type="button"
                  role="tab"
                >
                  Familiar
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-estudios"
                  type="button"
                  role="tab"
                >
                  Estudios
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-firma-aprendiz"
                  type="button"
                  role="tab"
                >
                  Firma Aprendiz
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-firma-acudiente"
                  type="button"
                  role="tab"
                >
                  Firma Acudiente
                </button>
              </li>
            </ul>
          </div>

          <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="tab-datos"
              role="tabpanel"
            >
              <div className="row g-4">
                <div className="col-12 col-lg-9">
                  <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 fw-semibold">Datos personales</h6>
                      <span className="text-secondary small">* Obligatorio</span>
                    </div>

                    <hr className="my-3" />

                    <div className="row g-3">
                      <div className="col-12 col-md-6 col-xl-3">
                        <label className="form-label small text-secondary text-uppercase">
                          Nombre 1 *
                        </label>
                        <input
                          className="form-control"
                          value={nombre1Aprendiz}
                          onChange={(e) => setNombre1Aprendiz(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6 col-xl-3">
                        <label className="form-label small text-secondary text-uppercase">
                          Nombre 2
                        </label>
                        <input
                          className="form-control"
                          value={nombre2Aprendiz}
                          onChange={(e) => setNombre2Aprendiz(e.target.value)}
                        />
                      </div>

                      <div className="col-12 col-md-6 col-xl-3">
                        <label className="form-label small text-secondary text-uppercase">
                          Apellido 1 *
                        </label>
                        <input
                          className="form-control"
                          value={apellido1Aprendiz}
                          onChange={(e) => setApellido1Aprendiz(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6 col-xl-3">
                        <label className="form-label small text-secondary text-uppercase">
                          Apellido 2
                        </label>
                        <input
                          className="form-control"
                          value={apellido2Aprendiz}
                          onChange={(e) => setApellido2Aprendiz(e.target.value)}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label small text-secondary text-uppercase">
                          Tipo de documento *
                        </label>
                        <select
                          className="form-select"
                          value={tipodocumentoAprendiz}
                          onChange={(e) =>
                            setTipodocumentoAprendiz(e.target.value)
                          }
                          required
                        >
                          <option value="">Seleccione</option>
                          <option value="CC">Cédula de Ciudadanía</option>
                          <option value="TI">Tarjeta de Identidad</option>
                          <option value="CE">Cédula de Extranjería</option>
                          <option value="PAS">Pasaporte</option>
                        </select>
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label small text-secondary text-uppercase">
                          Documento *
                        </label>
                        <input
                          className="form-control"
                          value={documentoAprendiz}
                          onChange={(e) => setDocumentoAprendiz(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6 col-xl-3">
                        <label className="form-label small text-secondary text-uppercase">
                          Fecha nacimiento *
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={fechanacimientoAprendiz}
                          onChange={(e) =>
                            setFechanacimientoAprendiz(e.target.value)
                          }
                          required
                        />
                      </div>

                      <div className="col-6 col-md-3">
                        <label className="form-label small text-secondary text-uppercase">
                          Edad
                        </label>
                        <select
                          className="form-select"
                          value={edadAprendiz}
                          onChange={(e) => setEdadAprendiz(e.target.value)}
                          required
                        >
                          <option value="">Seleccione</option>
                          {edades.map((edad) => (
                            <option key={edad} value={edad}>
                              {edad}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-6 col-md-3">
                        <label className="form-label small text-secondary text-uppercase">
                          Sexo *
                        </label>
                        <select
                          className="form-select"
                          value={sexoAprendiz}
                          onChange={(e) => setSexoAprendiz(e.target.value)}
                          required
                        >
                          <option value="">Seleccione</option>
                          {sexos.map((sexo, idx) => (
                            <option key={idx} value={sexo.valor}>
                              {sexo.etiqueta}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-12 col-md-3">
                        <label className="form-label small text-secondary text-uppercase">
                          RH *
                        </label>
                        <select
                          className="form-select"
                          value={rhAprendiz}
                          onChange={(e) => setRhAprendiz(e.target.value)}
                          required
                        >
                          <option value="">Seleccione</option>
                          {gruposSanguineos.map((g) => (
                            <option key={g} value={g}>
                              {g}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 fw-semibold">Contacto</h6>
                      <span className="text-secondary small">* Obligatorio</span>
                    </div>

                    <hr className="my-3" />

                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label small text-secondary text-uppercase">
                          Dirección
                        </label>
                        <input
                          className="form-control"
                          value={direccionAprendiz}
                          onChange={(e) => setDireccionAprendiz(e.target.value)}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label small text-secondary text-uppercase">
                          Correo *
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={emailAprendiz}
                          onChange={(e) => setEmailAprendiz(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label small text-secondary text-uppercase">
                          Teléfono 1 *
                        </label>
                        <input
                          className="form-control"
                          value={telefono1Aprendiz}
                          onChange={(e) => setTelefono1Aprendiz(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label small text-secondary text-uppercase">
                          Teléfono 2
                        </label>
                        <input
                          className="form-control"
                          value={telefono2Aprendiz}
                          onChange={(e) => setTelefono2Aprendiz(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 fw-semibold">Ubicación</h6>
                      <span className="text-secondary small">* Obligatorio</span>
                    </div>

                    <hr className="my-3" />

                    <div className="row g-3">
                      <div className="col-12 col-md-4">
                        <label className="form-label small text-secondary text-uppercase">
                          País
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => handlePaisChange(e.target.value)}
                          value={paisSeleccionado || paisAprendiz || ""}
                        >
                          <option value="">Seleccione</option>

                          {paises?.length ? (
                            [...paises]
                              .sort((a, b) =>
                                a.nombrePais.localeCompare(b.nombrePais, "es", {
                                  sensitivity: "base",
                                })
                              )
                              .map((p) => (
                                <option key={p.idPais} value={p.idPais}>
                                  {p.nombrePais}
                                </option>
                              ))
                          ) : (
                            <option disabled>Cargando...</option>
                          )}
                        </select>
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label small text-secondary text-uppercase">
                          Estado
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => handleEstadoChange(e.target.value)}
                          value={estadoSeleccionado || estadoAprendiz || ""}
                          disabled={!paisSeleccionado && !paisAprendiz}
                        >
                          <option value="">Seleccione</option>

                          {estados?.length ? (
                            [...estados]
                              .sort((a, b) =>
                                a.nombreEstado.localeCompare(
                                  b.nombreEstado,
                                  "es",
                                  { sensitivity: "base" }
                                )
                              )
                              .map((x) => (
                                <option key={x.idEstado} value={x.idEstado}>
                                  {x.nombreEstado}
                                </option>
                              ))
                          ) : (
                            <option disabled>
                              {paisSeleccionado || paisAprendiz
                                ? "Cargando..."
                                : "Seleccione país"}
                            </option>
                          )}
                        </select>
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label small text-secondary text-uppercase">
                          Ciudad
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => handleCiudadChange(e.target.value)}
                          value={ciudadSeleccionada || ciudadAprendiz || ""}
                          disabled={!estadoSeleccionado && !estadoAprendiz}
                        >
                          <option value="">Seleccione</option>

                          {ciudades?.length ? (
                            [...ciudades]
                              .sort((a, b) =>
                                a.nombreCiudad.localeCompare(
                                  b.nombreCiudad,
                                  "es",
                                  { sensitivity: "base" }
                                )
                              )
                              .map((c) => (
                                <option key={c.idCiudad} value={c.idCiudad}>
                                  {c.nombreCiudad}
                                </option>
                              ))
                          ) : (
                            <option disabled>
                              {estadoSeleccionado || estadoAprendiz
                                ? "Cargando..."
                                : "Seleccione estado"}
                            </option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-3">
                  <div className="sticky-top" style={{ top: 16 }}>
                    <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-0 fw-semibold">Fotografía</h6>
                        <span className="badge text-bg-light border text-secondary rounded-pill">
                          Opcional
                        </span>
                      </div>

                      <hr className="my-3" />

                      <div className="border rounded-4 overflow-hidden bg-white">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ height: 420 }}
                        >
                          {preview ? (
                            <img
                              src={preview}
                              alt="Vista previa"
                              className="w-100 h-100"
                              style={{ objectFit: "cover" }}
                            />
                          ) : (
                            <div className="text-center text-secondary px-3">
                              <div className="fs-1 mb-2">👤</div>
                              <div className="fw-semibold">Sin imagen</div>
                              <div className="small">
                                Selecciona una fotografía
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="mt-3">
                        <input
                          type="file"
                          id="fileInput"
                          name="imgAprendiz"
                          className="d-none"
                          accept="image/*"
                          capture="environment"
                          onChange={handleFileChange}
                          disabled={!tienePermisoFormulario}
                        />

                        <div className="input-group">
                          <span className="input-group-text bg-white text-secondary">
                            Archivo
                          </span>
                          <input
                            type="text"
                            id="fileName"
                            className="form-control text-secondary"
                            placeholder="Ningún archivo seleccionado"
                            readOnly
                          />
                        </div>

                        <label
                          id="fileLabel"
                          htmlFor="fileInput"
                          className={`btn w-100 mt-2 fw-semibold ${
                            tienePermisoFormulario
                              ? "btn-outline-secondary"
                              : "btn-outline-secondary disabled"
                          }`}
                        >
                          Seleccionar / Cambiar
                        </label>

                        <div className="alert alert-light border mt-3 mb-0 small text-secondary">
                          Recomendación: buena iluminación y fondo neutro.
                        </div>
                      </div>
                    </div>

                    <div className="mt-3 bg-white border rounded-4 shadow-sm p-3">
                      <div className="small text-secondary">
                        <i className="fa-regular fa-circle-check me-2"></i>
                        La imagen se optimiza automáticamente antes de enviarse.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                        <div className="tab-pane fade" id="tab-familia" role="tabpanel">
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div>
                    <h6 className="mb-0 fw-semibold">Acudientes</h6>
                    <small className="text-secondary">
                      Máximo 3. Marca uno como principal.
                    </small>
                  </div>

                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={agregarAcudiente}
                    disabled={
                      acudientesAprendiz.length >= 3 || !tienePermisoFormulario
                    }
                  >
                    <i className="fa-solid fa-plus me-2"></i>
                    Agregar acudiente
                  </button>
                </div>

                <hr className="my-3" />

                <div className="row g-3">
                  {acudientesAprendiz?.length ? (
                    acudientesAprendiz.map((acudiente, index) => (
                      <div
                        key={acudiente?._id || index}
                        className="col-12 col-md-6 col-xl-4"
                      >
                        <div className="border rounded-4 p-3 h-100">
                          <div className="d-flex justify-content-between align-items-start gap-2">
                            <div>
                              <div className="fw-semibold">
                                {acudiente.acudientePrincipal
                                  ? "Acudiente Principal"
                                  : `Acudiente ${index + 1}`}
                              </div>
                              <div className="small text-secondary">
                                Datos de contacto y relación.
                              </div>
                            </div>

                            {acudientesAprendiz.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-link p-0 border-0 text-danger"
                                onClick={() => eliminarAcudiente(index)}
                                title="Eliminar"
                                disabled={!tienePermisoFormulario}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            )}
                          </div>

                          <hr className="my-3" />

                          <div className="mb-3">
                            <label className="form-label small text-secondary text-uppercase">
                              Nombre completo
                            </label>
                            <input
                              className="form-control"
                              name="nombreAcudiente"
                              value={acudiente.nombreAcudiente || ""}
                              onChange={(e) => handleAcudienteChange(index, e)}
                              disabled={!tienePermisoFormulario}
                            />
                          </div>

                          <div className="row g-2">
                            <div className="col-6">
                              <label className="form-label small text-secondary text-uppercase">
                                Tipo
                              </label>
                              <select
                                className="form-select"
                                name="tipodocumentoAcudiente"
                                value={acudiente.tipodocumentoAcudiente || ""}
                                onChange={(e) =>
                                  handleAcudienteChange(index, e)
                                }
                                disabled={!tienePermisoFormulario}
                              >
                                <option value="">Seleccione</option>
                                <option value="CC">CC</option>
                                <option value="CE">CE</option>
                              </select>
                            </div>

                            <div className="col-6">
                              <label className="form-label small text-secondary text-uppercase">
                                Documento
                              </label>
                              <input
                                className="form-control"
                                name="documentoAcudiente"
                                value={acudiente.documentoAcudiente || ""}
                                onChange={(e) =>
                                  handleAcudienteChange(index, e)
                                }
                                disabled={!tienePermisoFormulario}
                              />
                            </div>
                          </div>

                          <div className="mt-2">
                            <label className="form-label small text-secondary text-uppercase">
                              Lugar expedición
                            </label>
                            <input
                              className="form-control"
                              name="lugardocumentoAcudiente"
                              value={acudiente.lugardocumentoAcudiente || ""}
                              onChange={(e) => handleAcudienteChange(index, e)}
                              disabled={!tienePermisoFormulario}
                            />
                          </div>

                          <div className="row g-2 mt-2">
                            <div className="col-6">
                              <label className="form-label small text-secondary text-uppercase">
                                Relación
                              </label>
                              <select
                                className="form-select"
                                name="relacionAcudiente"
                                value={acudiente.relacionAcudiente || ""}
                                onChange={(e) =>
                                  handleAcudienteChange(index, e)
                                }
                                disabled={!tienePermisoFormulario}
                              >
                                <option value="">Seleccione</option>
                                <option value="Padre">Padre</option>
                                <option value="Madre">Madre</option>
                                <option value="Abuelo">Abuelo(a)</option>
                                <option value="Tío">Tío(a)</option>
                                <option value="Primo">Primo(a)</option>
                              </select>
                            </div>

                            <div className="col-6">
                              <label className="form-label small text-secondary text-uppercase">
                                Teléfono
                              </label>
                              <input
                                className="form-control"
                                name="telefonoAcudiente"
                                value={acudiente.telefonoAcudiente || ""}
                                onChange={(e) =>
                                  handleAcudienteChange(index, e)
                                }
                                disabled={!tienePermisoFormulario}
                              />
                            </div>
                          </div>

                          <div className="mt-2">
                            <label className="form-label small text-secondary text-uppercase">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              name="emailAcudiente"
                              value={acudiente.emailAcudiente || ""}
                              onChange={(e) => handleAcudienteChange(index, e)}
                              disabled={!tienePermisoFormulario}
                            />
                          </div>

                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="acudientePrincipal"
                                checked={!!acudiente.acudientePrincipal}
                                onChange={(e) =>
                                  handleAcudienteChange(index, e)
                                }
                                disabled={!tienePermisoFormulario}
                              />
                              <label className="form-check-label text-secondary small">
                                Principal
                              </label>
                            </div>

                            {acudiente.acudientePrincipal && (
                              <button
                                type="button"
                                className="btn btn-outline-dark btn-sm"
                                onClick={() =>
                                  navegarFirmaAcudiente(acudiente._id)
                                }
                                disabled={!acudiente?._id || !puedeActualizar}
                                title={
                                  !acudiente?._id
                                    ? "Guarda primero para generar ID"
                                    : !puedeActualizar
                                    ? "Sin permiso para actualizar"
                                    : "Registrar firma"
                                }
                              >
                                <i className="fa-solid fa-signature me-2"></i>
                                Firma
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-secondary py-5">
                      No hay acudientes registrados.
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="tab-pane fade" id="tab-estudios" role="tabpanel">
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div>
                    <h6 className="mb-0 fw-semibold">Estudios</h6>
                    <small className="text-secondary">
                      Registra el historial académico.
                    </small>
                  </div>

                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={agregarEstudio}
                    disabled={!tienePermisoFormulario}
                  >
                    <i className="fa-solid fa-plus me-2"></i>
                    Agregar estudio
                  </button>
                </div>

                <hr className="my-3" />

                <div className="d-flex flex-column gap-3">
                  {estudiosAprendiz?.length ? (
                    estudiosAprendiz.map((estudio, index) => (
                      <div key={index} className="border rounded-4 p-3">
                        <div className="row g-2 align-items-end">
                          <div className="col-12 col-md-3">
                            <label className="form-label small text-secondary text-uppercase">
                              Nivel
                            </label>
                            <select
                              className="form-select"
                              name="nivel"
                              value={estudio.nivel}
                              onChange={(e) => handleEstudioChange(index, e)}
                              disabled={!tienePermisoFormulario}
                            >
                              <option value="">Seleccione</option>
                              <option value="Bachiller">Bachiller</option>
                              <option value="Técnico">Técnico</option>
                              <option value="Tecnólogo">Tecnólogo</option>
                              <option value="Pregrado">Pregrado</option>
                              <option value="Posgrado">Posgrado</option>
                            </select>
                          </div>

                          <div className="col-12 col-md-4">
                            <label className="form-label small text-secondary text-uppercase">
                              Institución
                            </label>
                            <input
                              className="form-control"
                              name="institucion"
                              value={estudio.institucion}
                              onChange={(e) => handleEstudioChange(index, e)}
                              disabled={!tienePermisoFormulario}
                            />
                          </div>

                          <div className="col-12 col-md-4">
                            <label className="form-label small text-secondary text-uppercase">
                              Título
                            </label>
                            <input
                              className="form-control"
                              name="tituloObtenido"
                              value={estudio.tituloObtenido}
                              onChange={(e) => handleEstudioChange(index, e)}
                              disabled={!tienePermisoFormulario}
                            />
                          </div>

                          <div className="col-8 col-md-1">
                            <label className="form-label small text-secondary text-uppercase">
                              Año
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="anioFinalizacion"
                              value={estudio.anioFinalizacion}
                              min="1900"
                              max={new Date().getFullYear()}
                              onChange={(e) => handleEstudioChange(index, e)}
                              disabled={!tienePermisoFormulario}
                            />
                          </div>

                          <div className="col-4 col-md-0 d-flex justify-content-end">
                            {estudiosAprendiz.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-link p-0 border-0 text-danger"
                                onClick={() => eliminarEstudio(index)}
                                title="Eliminar"
                                disabled={!tienePermisoFormulario}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-secondary py-5">
                      No hay estudios registrados.
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="tab-firma-aprendiz"
              role="tabpanel"
            >
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 text-center">
                <h6 className="fw-semibold mb-3">Firma del aprendiz</h6>

                <div className="mx-auto w-100" style={{ maxWidth: 520 }}>
                  <div className="ratio ratio-21x9 border rounded-4 bg-body-tertiary overflow-hidden">
                    {previewFirmaAprendiz ? (
                      <img
                        src={previewFirmaAprendiz}
                        alt="Firma aprendiz"
                        className="img-fluid p-2"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <div className="d-flex align-items-center justify-content-center text-secondary small">
                        No hay firma registrada
                      </div>
                    )}
                  </div>

                  <div>
                    <button
                      type="button"
                      className="btn btn-dark mt-3 w-100 w-md-auto px-3 px-md-2 py-2 py-md-2 fs-6 fs-md-6"
                      disabled={!puedeActualizar}
                      title={
                        puedeActualizar
                          ? "Registrar firma"
                          : "Sin permiso para actualizar"
                      }
                      onClick={() => {
                        if (!puedeActualizar) {
                          return Swal.fire(
                            "Sin permisos",
                            "No tiene permisos para registrar la firma del aprendiz.",
                            "warning"
                          );
                        }

                        const targetId = aprendizFromState?._id || id;

                        if (!targetId) {
                          return Swal.fire({
                            icon: "warning",
                            title: "Guarda primero el aprendiz",
                          });
                        }

                        navigate(`/aprendiz/registrarfirma/${targetId}`);
                      }}
                    >
                      <i className="fa-solid fa-signature me-2"></i>
                      Registrar firma
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="tab-firma-acudiente"
              role="tabpanel"
            >
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 text-center">
                <h6 className="fw-semibold mb-3">Firma del acudiente</h6>

                {acudientesAprendiz?.length > 1 && (
                  <div className="mb-3 mx-auto w-100" style={{ maxWidth: 520 }}>
                    <select
                      className="form-select"
                      value={selectedAcudienteId || ""}
                      onChange={(e) => setSelectedAcudienteId(e.target.value)}
                    >
                      {acudientesAprendiz.map((a, idx) => (
                        <option key={a?._id || idx} value={a?._id || ""}>
                          {a?.acudientePrincipal
                            ? "Acudiente Principal"
                            : a?.nombreAcudiente || `Acudiente ${idx + 1}`}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="mx-auto w-100" style={{ maxWidth: 520 }}>
                  <div className="ratio ratio-21x9 border rounded-4 bg-body-tertiary overflow-hidden">
                    {previewFirmaAcudiente ? (
                      <img
                        src={previewFirmaAcudiente}
                        alt="Firma acudiente"
                        className="img-fluid p-2"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <div className="d-flex align-items-center justify-content-center text-secondary small">
                        No hay firma registrada
                      </div>
                    )}
                  </div>

                  <div>
                    <button
                      type="button"
                      className="btn btn-dark mt-3 w-100 w-md-auto px-3 px-md-2 py-2 py-md-2 fs-6 fs-md-6"
                      disabled={!acudienteActual?._id || !puedeActualizar}
                      title={
                        !acudienteActual?._id
                          ? "Guarda primero para generar ID"
                          : !puedeActualizar
                          ? "Sin permiso para actualizar"
                          : "Registrar firma"
                      }
                      onClick={() => {
                        if (!puedeActualizar) {
                          return Swal.fire(
                            "Sin permisos",
                            "No tiene permisos para registrar la firma del acudiente.",
                            "warning"
                          );
                        }

                        acudienteActual?._id &&
                          navegarFirmaAcudiente(acudienteActual._id);
                      }}
                    >
                      <i className="fa-solid fa-signature me-2"></i>
                      Agregar firma
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3 mt-3">
            <div className="col-12 col-md-6">
              <button
                type="submit"
                className="btn btn-dark w-100 fw-semibold py-2"
                disabled={loading || !tienePermisoFormulario}
                style={{
                  opacity: tienePermisoFormulario ? 1 : 0.5,
                  cursor: tienePermisoFormulario ? "pointer" : "not-allowed",
                }}
                title={
                  tienePermisoFormulario
                    ? edit
                      ? "Guardar cambios"
                      : "Registrar aprendiz"
                    : edit
                    ? "Sin permiso para actualizar"
                    : "Sin permiso para crear"
                }
              >
                {loading
                  ? "Guardando…"
                  : edit
                  ? "Guardar cambios"
                  : "Registrar"}
              </button>
            </div>

            <div className="col-12 col-md-6">
              <button
                type="button"
                className={`btn w-100 fw-semibold py-2 ${
                  edit ? "btn-outline-danger" : "btn-outline-secondary"
                }`}
                onClick={handleCancelOrClean}
                disabled={loading}
              >
                {edit ? "Cancelar" : "Limpiar"}
              </button>
            </div>

            {loading && (
              <div className="col-12">
                <div className="d-flex justify-content-between">
                  <small className="text-secondary">Subiendo…</small>
                  <small className="text-secondary fw-semibold">
                    {uploadState}%
                  </small>
                </div>

                <div className="progress mt-2" style={{ height: 10 }}>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${uploadState}%` }}
                  />
                </div>
              </div>
            )}
          </div>
        </form>

        <div className="mt-4 text-center text-secondary small">
          Verifica la información antes de{" "}
          {edit ? "guardar cambios" : "registrar"}.
          {edit ? <span className="ms-2">ID: {documentoAprendiz}</span> : null}
        </div>
      </div>
    </div>
  );
};

export default RegistrarAprendices;